Vendd.Scripts.load(function () {

    var Vendd = window.Vendd;

    Vendd.logger.init();

    Vendd.api.init()
        .then(function() {

            //Vendd.inlineEdit.init();

        })
        .then(null, function () {

            debugger;

        });

});